import React, { useState } from 'react';
import { StyledTableWrapper, getUpdateDiv, tableRender } from './common';

export const columns = [
  {
    column: 'order',
    label: '打序',
    className: 'first',
  },
  {
    column: 'player.number',
    label: '背號',
  },
  {
    column: 'player.name',
    label: '名稱',
  },
  {
    column: 'PA',
    label: '打席',
    updatable: Number,
  },
  {
    column: 'AB',
    label: '打數',
    updatable: Number,
  },
  {
    column: 'R',
    label: '得分',
    updatable: Number,
  },
  {
    column: 'H',
    label: '安打',
    updatable: Number,
  },
  {
    column: 'RBI',
    label: '打點',
    updatable: Number,
  },
  {
    column: '2B',
    label: '二安',
    updatable: Number,
  },
  {
    column: '3B',
    label: '三安',
    updatable: Number,
  },
  {
    column: 'HR',
    label: '全壘打',
    updatable: Number,
  },
  {
    column: 'GIDP',
    label: '滾地雙殺',
    updatable: Number,
  },
  {
    column: 'DP',
    label: '雙殺',
    updatable: Number,
  },
  {
    column: 'TP',
    label: '三殺',
    updatable: Number,
  },
  {
    column: 'BB',
    label: '四壞',
    updatable: Number,
  },
  {
    column: 'IBB',
    label: '故意四壞',
    updatable: Number,
  },
  {
    column: 'HBP',
    label: '觸身',
    updatable: Number,
  },
  {
    column: 'SO',
    label: '三振',
    updatable: Number,
  },
  {
    column: 'SH',
    label: '犧短',
    updatable: Number,
  },
  {
    column: 'SF',
    label: '犧飛',
    updatable: Number,
  },
  {
    column: 'E',
    label: '失誤上壘',
    updatable: Number,
  },
  {
    column: 'SB',
    label: '盜壘',
    updatable: Number,
  },
  {
    column: 'CS',
    label: '盜壘失敗',
    updatable: Number,
  },
];

const FormalGameBoxBatting = ({ players, battings, handleUpdate }) => {
  const [selectedRow, setSelectedRow] = useState(-1);
  const [selectColumn, setSelectColumn] = useState('');

  return (
    <div>
      {getUpdateDiv(battings, columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn, handleUpdate)}
      <StyledTableWrapper>
        {tableRender(battings, columns, setSelectedRow, setSelectColumn, selectedRow, selectColumn)}
      </StyledTableWrapper>
    </div>
  );
};

export default FormalGameBoxBatting;
